
import { Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';

import DefaultModal from '@/components/Modal/DefaultModal';
import ImgModal from '@/components/Modal/ImgModal';

interface IModal {
  dataSource?: any;
}


@Component
export default class ModalList extends tsx.Component<IModal> {

  @Prop({default: () =>[]}) public dataSource?: any

  render() {

    const { dataSource = [] } = this.$props
    console.log(dataSource);
    return  (
      <div>
      {dataSource.map((data, key) => {
        if (!data.visible) return false
        return data.bodyType === 1 ? <DefaultModal  key={key} data={data}/> : <ImgModal  key={key} data={data}/>
      })}
      </div>
    )
    
  }
  
}